import gsap, { Power1 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { isDebug } from '../_app/cuchillo/core/Basics';

export default class Preloader {
    _container;
    _progress;

    static init() {
       GetBy.id('Preloader').style.display = "none";
    }

    static update(__progress) {
        
    }

    static hide(__call) {
       if (__call) __call();
    }
}
